<template>
  <div class="row">
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-warning">
        <span class="info-box-icon"><i class="far fa-thumbs-up"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Link to HIV care</span>
          <div class="info-box-number">
            {{ Number(linktocare).toLocaleString() }}% -
            <span class="float-right">{{ Number(90).toLocaleString() }}%</span>
          </div>

          <div class="progress">
            <!-- 26,0000 -->
            <div class="progress-bar" v-bind:style="{ width: linktocarePercentage + '%' }"></div>
          </div>
          <span class="progress-description"> {{ Number(linktocarePercentage).toLocaleString() }}% achieved </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-success">
        <span class="info-box-icon"><i class="far fa-thumbs-up"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Adherent</span>
          <span class="info-box-number">{{ Number(adherent).toLocaleString() }} </span>

          <!-- <div class="progress">
                            <div class="progress-bar" style="width: 20%"></div>
                        </div>
                        <span class="progress-description"> </span> -->
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-cyan">
        <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Regular discharge AAU</span>
          <span class="info-box-number">{{ Number(rdAAU).toLocaleString() }}</span>

          <!-- <div class="progress">
                    <div class="progress-bar" style="width: 30%"></div>
                </div>
                <span class="progress-description">
                </span> -->
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-danger">
        <span class="info-box-icon"><i class="fas fa-vial"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">AAU referral</span>
          <span class="info-box-number"> {{ Number(aauReferral).toLocaleString() }} </span>

          <!-- <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div>
                        <span class="progress-description">
                        </span> -->
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
  </div>
</template>

<script>
export default {
  name: "smz-indicators",
  data() {
    return {
        indicators : null,
        linktocare : null,
        linktocarePercentage : null,
        adherent : null,
        rdAAU : null,
        aauReferral : null,
    };
  },
  methods: {
    async callNsepIndicators() {
      await axios
        .get("plhivIndicators")
        .then((response) => {
          if (response.status == 200) {
            this.indicators = response.data;
            this.linktocare = this.indicators.LinktoCare;
            this.linktocarePercentage = ((this.linktocare / 90) * 100).toFixed(0);
            this.adherent = this.indicators.Adherent;
            this.rdAAU = this.indicators.AAU_RD;
            this.aauReferral = this.indicators.AAU_Referal;

            // percentage calculation
            // this.spouseRegPercentage = parseFloat(
            //   (parseInt(this.spouseReg) / 13500) * 100
            // ).toFixed(0);
            // this.preventiveProgramPercentage = parseFloat(
            //   (parseInt(this.preventiveProgram) / 2592) * 100
            // ).toFixed(0);
            // this.lspPercentage = parseFloat(parseFloat(this.lsp) * 100).toFixed(
            //   0
            // );
            // this.pptctPercentage = parseFloat(
            //   (parseInt(this.pptct) / 250) * 100
            // ).toFixed(0);
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
    this.callNsepIndicators();
  },
};
</script>

<style lang="scss" scoped>
</style>
